module.exports = __webpack_public_path__ + "static/img/top-bg2.450e1646.png";